import React from 'react';
import { Link } from 'react-router-dom';
import { Analytics } from '../../components/admin/Analytics';

const AdminAdAnalytics: React.FC = () => {
  return (
    <main className="mx-auto max-w-6xl px-4 py-8 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-100">Ad Analytics</h1>
          <p className="text-sm text-slate-600 dark:text-slate-400">
            Performance metrics, audience demographics, and campaign insights.
          </p>
        </div>
        <Link
          to="/admin"
          className="inline-flex items-center rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-3 py-1.5 text-xs font-medium text-slate-700 dark:text-slate-300 shadow-sm hover:bg-slate-50"
        >
          Back to admin
        </Link>
      </div>

      <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-4 shadow-sm">
        <Analytics />
      </div>
    </main>
  );
};

export default AdminAdAnalytics;
